import { classNames } from 'libs/react';
import { React } from 'libs/react';
import './FileName.scss';
/**
 * @component FileName
 * @since 1.0.0
 */
export function FileName(props) {
    const { style, value } = Object.assign({ style: 'normal' }, props);
    const parts = value.split('.');
    const className = classNames('file-name', 'file-name--' + style, props.className);
    return (React.createElement("span", { className: className },
        React.createElement("span", { className: "file-name-base" },
            parts[0],
            ".",
            parts[1])));
}
